import {
  formatRelativeTime,
  isRecent,
  type ResolvedDateTimeFormat,
  toDate,
} from "@/shared/datetime";

/**
 * When something was verified: "3 minutes ago" within a day of `timestamp`,
 * else its date and time in `dateTimeFormat`. Pass the caller's
 * `useDateTimeFormat()`, so the text follows the viewer's preference.
 */
export function verifiedWhen(
  timestamp: string,
  dateTimeFormat: ResolvedDateTimeFormat,
): string {
  const date = toDate(timestamp);
  if (date === null) {
    return "";
  }
  return isRecent(date)
    ? formatRelativeTime(date)
    : dateTimeFormat.format(date);
}
